import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { useParams } from 'react-router';
import { CustomInput, Icon, Modal, NoResult, Text } from '../..';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import { Footer, PagContainer, ScrollableArea } from '../style';
import { MODAL_CLOSE } from '../../../../app/redux/actions';
import { USER_GROUPS_GET } from '../../../../app/redux/actions/statistics';
import theme from '../../../theme';
import SortBy from '../../SortBy';
import Pagination from '../../Pagination';
import { GroupCard, Legend } from './style';
import { timestampToDate } from '../../../../utils/common';

export const ModalUserGroupsId = 'ModalUserGroups';

const ModalUserGroups = ({
  mediaIsPhone,
  list,
  pager,
  getUserGroups,
  modalClose,
}) => {
  const scrollableAreaRef = useRef(null);
  const { user_id } = useParams();
  // filters
  const [selectedFilters, setSelectedFilters] = useState({ user_id });
  const [searchValue, setSearchValue] = useState();

  useEffect(() => {
    getUserGroups(selectedFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_id]);

  useEffect(() => {
    if (Object.keys(selectedFilters)?.length > 0) {
      getUserGroups(selectedFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, search_text: searchValue });
  };

  const loadMore = (page) => getUserGroups({ ...selectedFilters, page });
  const setItemsPerPage = (v) =>
    getUserGroups({ ...selectedFilters, items_per_page: v?.value });

  return (
    <Modal
      title="Gruppi di appartenenza"
      modalId={ModalUserGroupsId}
      scrollableAreaRef={scrollableAreaRef}
      className="overflow-x-hidden"
    >
      <Text type="b3" mb={24}>
        Di seguito sono mostrati i gruppi ai quali l’utente è associato.
      </Text>
      <Text type="b3" mb={32}>
        {pager?.total_items || 0} gruppi
        <Icon
          type="users-01"
          clickable={false}
          className="ml-2"
          stroke={theme().colors.textPrimary}
        />
      </Text>
      <div className="d-flex sb g-48 mb-4">
        <CustomInput
          placeholder="Cosa vuoi cercare?..."
          isSearch
          value=""
          icon="search-sm"
          isClearable
          onChange={(v) => setSearchValue(v)}
          onClickIcon={onClickSearch}
          onKeyPress={(event) => {
            if (event.key === 'Enter') onClickSearch();
          }}
        />{' '}
        <SortBy
          onChange={(v) => {
            setSelectedFilters({ ...selectedFilters, sort_by: v?.value });
          }}
        />
      </div>
      {list?.length > 0 && (
        <Legend>
          <Text type="h3.5">Nome gruppo</Text>
          <Text type="h3.5">N. utenti</Text>
          <Text type="h3.5">Data di pubblicazione</Text>
        </Legend>
      )}
      <ScrollableArea ref={scrollableAreaRef} className="fullwidth">
        {list?.length > 0 ? (
          list.map((g, i) => (
            <GroupCard key={`group-${i}`}>
              <Text type="h3" className="title">
                {g?.name}
              </Text>
              <Text type="b4">{g?.total_users}</Text>
              <Text type="b4">{timestampToDate(g?.creation_date)}</Text>
            </GroupCard>
          ))
        ) : (
          <NoResult />
        )}
      </ScrollableArea>
      <Footer>
        <PagContainer>
          <Pagination
            pager={pager}
            callBack={loadMore}
            setItemsPerPage={setItemsPerPage}
          />
        </PagContainer>
      </Footer>
    </Modal>
  );
};

ModalUserGroups.propTypes = {
  //HOC: withMediaQueries
  mediaIsPhone: PropTypes.bool,
  // state
  list: PropTypes.array,
  pager: PropTypes.object,
  // dispatch
  modalClose: PropTypes.func.isRequired,
  getUserGroups: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { list, pager } = state.statistics.groups;
      return { list, pager };
    },
    (dispatch) => ({
      modalClose: () => dispatch({ type: MODAL_CLOSE }),
      getUserGroups: (filters) =>
        dispatch({ type: USER_GROUPS_GET._REQUEST, filters }),
    })
  ),
  withMediaQueries
)(ModalUserGroups);
